var _line, _path, _path2, _path3, _path4, _path5, _path6, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCactusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 75,
    viewBox: "0 0 95 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 67.5,
    x2: 95,
    y2: 67.5,
    stroke: "#9097A3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65 71L86 71",
    stroke: "#9097A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5273 8.76333C15.6645 11.8931 14.5 18.3672 14.5 30.5C14.5 39.682 16.7796 46.2709 19.1573 50.6489C21.8212 55.5541 27.4516 57.5 33.2142 57.5C33.8245 57.5 34.4002 57.1779 34.9044 56.5767C35.4097 55.9742 35.8079 55.128 36.0429 54.1974C36.2775 53.2685 36.3408 52.289 36.2063 51.4353C36.071 50.5759 35.7451 49.8959 35.2521 49.4884C29.8892 45.0551 25.2335 38.81 25.2335 30.5C25.2335 18.1977 23.9428 11.7168 23.0106 8.64215C22.6009 7.29111 21.3176 6.5 19.8045 6.5C18.2393 6.5 16.9175 7.34777 16.5273 8.76333Z",
    fill: "#F1F3F5",
    stroke: "#9097A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6299 7.10756C21.5492 7.02905 21.4408 7 21.3283 7V7C20.9075 7 20.5801 7.39475 20.6396 7.81123C20.9146 9.73454 21.5 15.5807 21.5 30.5C21.5 42.5777 25.528 46.983 28.5943 48.5868C30.6712 49.6731 33.1202 49.9761 35.2773 50.8928V50.8928C37.1459 51.687 37.2633 51.581 35.6408 50.3604C29.9673 46.0921 25 39.7219 25 30.5C25 11.4889 22.2634 7.72437 21.6299 7.10756Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0005 4.90581L44.5005 19.5301L45.4348 71.3885C45.4618 72.8844 44.0581 73.9991 42.6048 73.6358C39.5845 72.8808 36.4202 72.8796 33.3998 73.6347C31.9409 73.9994 30.5468 72.8966 30.5805 71.4059C30.8282 60.4454 31.5856 27.8013 31.9994 19.525C32.283 13.8521 32.8897 8.33735 33.3603 4.63595C33.6632 2.25409 35.7035 0.5 38.1197 0.5C40.6356 0.5 42.7438 2.40303 43.0005 4.90581Z",
    fill: "white",
    stroke: "#9097A3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0243 3.98415C34.2798 2.25293 35.7739 1 37.5239 1V1C37.7827 1 37.9886 1.21702 37.9749 1.47547L37 19.98L37.9556 69.692C37.9818 71.0526 37.0888 72.2603 35.7803 72.6342L33.6199 73.2515C32.3213 73.6225 31.0355 72.6426 31.071 71.2925C31.3276 61.5272 32.2077 28.2578 32.5 19.98C32.7243 13.6302 33.5071 7.48749 34.0243 3.98415Z",
    fill: "#F1F3F5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9663 9.27786C62.2044 12.9175 64.5 20.6861 64.5 28.2019C64.5 33.281 61.5073 39.181 58.4694 43.8428C55.1448 48.9445 49.2098 51.5 43.0435 51.5C42.5471 51.5 42.0674 51.2091 41.6426 50.6236C41.219 50.0396 40.8977 49.2199 40.7294 48.3304C40.5615 47.4428 40.5535 46.5249 40.7215 45.7579C40.8915 44.9821 41.2235 44.4314 41.6714 44.159C47.5735 40.5692 52.7062 35.6343 53.4303 29.1226C54.5415 19.1288 55.2429 13.1325 55.622 9.96725C55.7911 8.5551 56.9885 7.5 58.4158 7.5C59.5777 7.5 60.6002 8.20159 60.9663 9.27786Z",
    fill: "white",
    stroke: "#9097A3"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 59.9293,
    y1: 14.505,
    x2: 66.9293,
    y2: 13.505,
    stroke: "#9097A3"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 53.3051,
    y1: 14.6039,
    x2: 58.9067,
    y2: 18.9192,
    stroke: "#9097A3"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 29.3051,
    y1: 33.6039,
    x2: 34.9067,
    y2: 37.9192,
    stroke: "#9097A3"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 63.2796,
    y1: 28.4145,
    x2: 59.2795,
    y2: 31.1126,
    stroke: "#9097A3"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 34.2051,
    y1: 61.456,
    x2: 28.205,
    y2: 64.1541,
    stroke: "#9097A3"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 45.2796,
    y1: 6.41452,
    x2: 41.2795,
    y2: 9.11258,
    stroke: "#9097A3"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 28.2796,
    y1: 44.4145,
    x2: 24.2796,
    y2: 47.1126,
    stroke: "#9097A3"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 25.8042,
    y1: 11.6712,
    x2: 23.0116,
    y2: 15.6059,
    stroke: "#9097A3"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 50.472,
    y1: 30.8351,
    x2: 52.8047,
    y2: 37.5103,
    stroke: "#9097A3"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 34.472,
    y1: 14.8351,
    x2: 36.8047,
    y2: 21.5103,
    stroke: "#9097A3"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 11.2213,
    y1: 37.3187,
    x2: 17.5555,
    y2: 40.4615,
    stroke: "#9097A3"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 12.2222,
    y1: 17.5521,
    x2: 18.5565,
    y2: 20.6949,
    stroke: "#9097A3"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 22.0112,
    y1: 30.2417,
    x2: 27.7361,
    y2: 26.0912,
    stroke: "#9097A3"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 41.7065,
    y1: 29.7456,
    x2: 47.4314,
    y2: 25.5952,
    stroke: "#9097A3"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 56.6081,
    y1: 43.0409,
    x2: 63.6675,
    y2: 42.6359,
    stroke: "#9097A3"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 41.9714,
    y1: 58.9061,
    x2: 49.0308,
    y2: 58.5012,
    stroke: "#9097A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCactusIcon);
export default __webpack_public_path__ + "static/media/cactus-icon.b88402fb4800b366550e817dad200fe7.svg";
export { ForwardRef as ReactComponent };